export type Preferences = {
  necessary: true
  analytics: boolean
  marketing: boolean
}
export type PreferencesConfig = Omit<Preferences, 'necessary'>

type VersionedPreferences = Preferences & { version: number }

const COOKIE_NAME = 'cookie-preferences'
// v1 -> v2: forzamos re-consentimiento para migrar la cookie al domain .zyrapp.com
// y que sea visible también en subdominios (dashboard.zyrapp.com)
const COOKIE_VERSION = 2
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365 // 1 year in seconds

const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost'

export const defaultPreferences = { necessary: true, analytics: false, marketing: false } as Preferences

export function readPreferences() {
  const match = document.cookie.match(new RegExp(`${COOKIE_NAME}=([^;]+)`))
  if (!match) return
  try {
    const { version, ...value } = JSON.parse(decodeURIComponent(match[1])) as VersionedPreferences
    if (typeof version !== 'number' || version < COOKIE_VERSION) return
    return value
  } catch {
    return
  }
}

export const writePreferences = (preferences: Preferences) => {
  const value = encodeURIComponent(JSON.stringify({ ...preferences, version: COOKIE_VERSION }))
  const domainAttr = isLocalhost ? '' : 'Domain=.zyrapp.com;'
  document.cookie = `${COOKIE_NAME}=${value}; Path=/; ${domainAttr} Max-Age=${COOKIE_MAX_AGE}; SameSite=Lax; Secure`
}
